
import { firebase as firebaseConfig, recaptchaKey } from "../../config.js"
import { initializeApp } from 'firebase/app';
import { CustomProvider, getToken, initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";

export async function initFirebase() {
	const app = initializeApp(firebaseConfig);

	if (location.hostname === 'localhost')
	{
		const functions = getFunctions(app, 'europe-west1');
		connectFunctionsEmulator(functions, 'localhost', 5001);

		const db = getFirestore(app);
		connectFirestoreEmulator(db, location.hostname, 8080);

		const auth = getAuth(app);
		connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });

		const storage = getStorage(app)
		connectStorageEmulator(storage, 'localhost', 9199)

		initializeAppCheck(app, {
			provider: new CustomProvider({
				getToken: () => {
					return Promise.resolve({
						token: "fake-token",
						expireTimeMillis: Date.now() + 1000 * 60 * 60 * 24,
					});
				}
			}),
			isTokenAutoRefreshEnabled: true,
		});

		return true;
	}
	else if (location.hostname.indexOf('trullock.uk') > -1)
	{
		const functions = getFunctions(app, 'europe-west1');
		connectFunctionsEmulator(functions, 'firebase-fns.trullock.uk', 5001);
		functions.emulatorOrigin = "https://firebase-fns.trullock.uk";

		const db = getFirestore(app);
		connectFirestoreEmulator(db, "firebase-firestore.trullock.uk", 8080);
		db._settings.host = "firebase-firestore.trullock.uk";
		db._settings.ssl = true;

		const auth = getAuth(app);
		connectAuthEmulator(auth, "https://firebase-auth.trullock.uk", { disableWarnings: true });
		
		const storage = getStorage(app)
		connectStorageEmulator(storage, 'firebase-storage.trullock.uk', 9199)
		storage._host = "firebase-storage.trullock.uk"
		storage._protocol = "https"

		initializeAppCheck(app, {
			provider: new CustomProvider({
				getToken: () => {
					return Promise.resolve({
						token: "fake-token",
						expireTimeMillis: Date.now() + 1000 * 60 * 60 * 24,
					});
				}
			}),
			isTokenAutoRefreshEnabled: true,
		});

		return true;
	}
	else
	{
		let appCheck = initializeAppCheck(app, {
			provider: new ReCaptchaV3Provider(recaptchaKey),
			isTokenAutoRefreshEnabled: true
		});

		try
		{
			let token = await getToken(appCheck, false)
			return true;
		}
		catch(e)
		{
			if(e.name == 'FirebaseError' && e.code.startsWith('appCheck'))
			{
				// seen:
				// - 'appCheck/initial-throttle' - Chrome Ingcognito
				// - 'appCheck/recaptcha-error' (when loading in local dev - https://github.com/WelcometoMyGarden/welcometomygarden/blob/7e08dff1765f0af4b649f16fbea7e17151af1c3c/src/routes/%2Blayout.svelte#L29-L52)
				// - 'appCheck/throttled' (when loading on Firefox on Android - https://github.com/WelcometoMyGarden/welcometomygarden/blob/7e08dff1765f0af4b649f16fbea7e17151af1c3c/src/routes/%2Blayout.svelte#L29-L52)
				console.error('Known AppCheck error', e)
				return false;
			}

			console.error(e)
			return false;
		}
		
	}
}